// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../css-loader/dist/cjs.js??ref--2-oneOf-0-1!../../../../packages/aem/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../packages/aem/node_modules/sass-loader/dist/cjs.js!../../../../packages/aem/node_modules/vue-loader/lib/index.js??vue-loader-options!./NsSectionHeader.vue?vue&type=style&index=0&lang=scss&module=true&");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../vue-style-loader/lib/addStylesClient.js").default
var update = add("5ccde7e4", content, false, {});
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../css-loader/dist/cjs.js??ref--2-oneOf-0-1!../../../../packages/aem/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../packages/aem/node_modules/sass-loader/dist/cjs.js!../../../../packages/aem/node_modules/vue-loader/lib/index.js??vue-loader-options!./NsSectionHeader.vue?vue&type=style&index=0&lang=scss&module=true&", function() {
     var newContent = require("!!../../../css-loader/dist/cjs.js??ref--2-oneOf-0-1!../../../../packages/aem/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../packages/aem/node_modules/sass-loader/dist/cjs.js!../../../../packages/aem/node_modules/vue-loader/lib/index.js??vue-loader-options!./NsSectionHeader.vue?vue&type=style&index=0&lang=scss&module=true&");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}